import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { UserPlanWidget } from '../components/UserPlanWidget';
import { IUserService } from '../user.service';

export const UserPlanWidgetContainer = observer((): ReactElement => {
  const userService = useInjection(IUserService.$);

  return (
    <UserPlanWidget
      planInfo={userService.data.planInfo}
      usedLimits={{
        usedSpace: userService.billing.usedSpace,
        workspaces: userService.billing.workspaces,
        workspaceUsers: userService.billing.workspaceUsers,
      }}
    />
  );
});
